export const CONVERSATION_RECORD_TYPE_OPTIONS = ["call", "chat"];

export const CONVERSATION_TIME_FILTER_OPTIONS = [
  "Today",
  "Yesterday",
  "This Week",
  "This Month",
  "Last Month",
  "Last 7 Days",
  "Last 30 Days",
  "Last 3 Months",
  "Custom Range",
];

export const getConversationQuickFilterDefaults = () => ({
  employee: "",
  team_name: "",
  time: "Last 7 Days",
  conversationId: "",
  record_type: "",
  customRangeType: "between",
  customStart: "",
  customEnd: "",
});

export const getConversationAdvancedFilterDefaults = () => ({
  fatal: "",
  type: "",
  conversation_type_reason: "",
  conversationPotential: "",
  refusalCategory: "",
  conversationOutcome: "",
  openConcerns: "",
  customerId: "",
  audioDuration: "",
  audioDurationLower: null,
  audioDurationUpper: null,
  scoreLower: null,
  scoreUpper: null,
  agent_feedback_multiple: [],
  business_insights_multiple: [],
  disposition: "",
  subdisposition: "",
  concernCategory: "",
  concernSubcategory: "",
  queryCategory: "",
  querySubcategory: "",
  conversation_direction: "",
  lead_source: "",
  primary_language: "",
  secondary_languages: "",
  lead_sub_source: "",
  tag: "",
  tag2: "",
  tag3: "",
  tag4: "",
  tag5: "",
  tag6: "",
  tag7: "",
  tag8: "",
  tag9: "",
  tag10: "",
  tag11: "",
  tag12: "",
  tag13: "",
  tag14: "",
  tag15: "",
  tag16: "",
  tag17: "",
  tag18: "",
  tag19: "",
  tag20: "",
  tag21: "",
  tag22: "",
  tag23: "",
  tag24: "",
  tag25: "",
  tag26: "",
  tag27: "",
  tag28: "",
  tag29: "",
  tag30: "",
  campaignId: "",
  campaignBatchId: "",
  actorType: "",
  first_proper_conversation: "",
  needsReview: "",
  crm_lead_stage: "",
  crm_lead_sub_stage: "",
  customer_phone_number: "",
  crm_location: "",
  crm_lead_created_at: "",
  crm_lead_created_at_start: "",
  crm_lead_created_at_end: "",
  crm_lead_created_at_range_type: "between",
  custom_module_multiple: [],
  custom_module_parameter_name: "",
  custom_module_parameter_answer: "",
});

export const getConversationAdvancedFilterOptionDefaults = () => ({
  employees: [],
  teams: [],
  team_names: [],
  refusal_category: [],
  conversation_outcome: [],
  customer_outcome: [],
  open_concerns_and_queries: ["Yes", "No"],
  audioDuration: [
    "Less than 1 Minute",
    "1-2 Minutes",
    "3-5 Minutes",
    "Above 2 Minutes",
    "More than 5 Minutes",
    "Custom Range",
  ],
  conversation_potential: [],
  conversation_type_reason: [],
  agent_feedback_parameters: [],
  business_insights_parameters: [],
  business_insight_parameters: [],
  concern_categories: [],
  concern_subcategories: [],
  query_categories: [],
  query_subcategories: [],
  disposition: [],
  subdisposition: [],
  lead_sources: [],
  primary_languages: [],
  secondary_languages: [],
  lead_sub_sources: [],
  tags: [],
  tags2: [],
  tags3: [],
  tag2: [],
  tag3: [],
  tag4: [],
  tag5: [],
  tag6: [],
  tag7: [],
  tag8: [],
  tag9: [],
  tag10: [],
  tag11: [],
  tag12: [],
  tag13: [],
  tag14: [],
  tag15: [],
  tag16: [],
  tag17: [],
  tag18: [],
  tag19: [],
  tag20: [],
  tag21: [],
  tag22: [],
  tag23: [],
  tag24: [],
  tag25: [],
  tag26: [],
  tag27: [],
  tag28: [],
  tag29: [],
  tag30: [],
  campaign_ids: [],
  campaign_batch_ids: [],
  lead_stages: [],
  lead_sub_stages: [],
  custom_module: [],
});

export const mergeConversationFilterDetails = (previous = {}, data = {}) => {
  const teams = data.team_names || data.team_name || data.teams || [];
  const conversationOutcome = data.conversation_outcome_list || data.customer_outcome || [];
  const businessInsights = data.business_insights || [];
  const tags = data.tags || [];
  const tags2 = data.tags2 || data.tag2 || tags;
  const tags3 = data.tags3 || data.tag3 || tags;
  const tags4 = data.tags4 || data.tag4 || tags;
  const tags5 = data.tags5 || data.tag5 || tags;
  const tags6 = data.tags6 || data.tag6 || tags;
  const tags7 = data.tags7 || data.tag7 || tags;
  const tags8 = data.tags8 || data.tag8 || tags;
  const tags9 = data.tags9 || data.tag9 || tags;
  const tags10 = data.tags10 || data.tag10 || tags;
  const tags11 = data.tags11 || data.tag11 || tags;
  const tags12 = data.tags12 || data.tag12 || tags;
  const tags13 = data.tags13 || data.tag13 || tags;
  const tags14 = data.tags14 || data.tag14 || tags;
  const tags15 = data.tags15 || data.tag15 || tags;
  const tags16 = data.tags16 || data.tag16 || tags;
  const tags17 = data.tags17 || data.tag17 || tags;
  const tags18 = data.tags18 || data.tag18 || tags;
  const tags19 = data.tags19 || data.tag19 || tags;
  const tags20 = data.tags20 || data.tag20 || tags;
  const tags21 = data.tags21 || data.tag21 || tags;
  const tags22 = data.tags22 || data.tag22 || tags;
  const tags23 = data.tags23 || data.tag23 || tags;
  const tags24 = data.tags24 || data.tag24 || tags;
  const tags25 = data.tags25 || data.tag25 || tags;
  const tags26 = data.tags26 || data.tag26 || tags;
  const tags27 = data.tags27 || data.tag27 || tags;
  const tags28 = data.tags28 || data.tag28 || tags;
  const tags29 = data.tags29 || data.tag29 || tags;
  const tags30 = data.tags30 || data.tag30 || tags;

  return {
    ...previous,
    employees: data.employee_id || [],
    teams,
    team_names: teams,
    conversation_type_reason: data.conversation_type_reason || [],
    conversation_outcome: conversationOutcome,
    customer_outcome: data.customer_outcome || conversationOutcome,
    refusal_category: data.refusal_category_list || data.refusal_category || [],
    conversation_potential: data.conversation_potential || [],
    agent_feedback_parameters: data.agent_feedback_parameters || [],
    business_insights_parameters: businessInsights,
    business_insight_parameters: businessInsights,
    concern_categories: data.concerns_category || [],
    concern_subcategories: data.concerns_subcategory || [],
    query_categories: data.query_category || [],
    query_subcategories: data.query_subcategory || [],
    disposition: data.disposition || [],
    subdisposition: data.subdisposition || [],
    lead_sources: data.lead_sources || [],
    primary_languages: data.primary_languages || data.primary_language || [],
    secondary_languages: data.secondary_languages || [],
    lead_sub_sources: data.lead_sub_sources || [],
    tags,
    tags2,
    tags3,
    tag2: tags2,
    tag3: tags3,
    tag4: tags4,
    tag5: tags5,
    tag6: tags6,
    tag7: tags7,
    tag8: tags8,
    tag9: tags9,
    tag10: tags10,
    tag11: tags11,
    tag12: tags12,
    tag13: tags13,
    tag14: tags14,
    tag15: tags15,
    tag16: tags16,
    tag17: tags17,
    tag18: tags18,
    tag19: tags19,
    tag20: tags20,
    tag21: tags21,
    tag22: tags22,
    tag23: tags23,
    tag24: tags24,
    tag25: tags25,
    tag26: tags26,
    tag27: tags27,
    tag28: tags28,
    tag29: tags29,
    tag30: tags30,
    campaign_ids: data.campaign_ids || [],
    campaign_batch_ids: data.campaign_batch_ids || [],
    lead_stages: data.lead_stages || [],
    lead_sub_stages: data.lead_sub_stages || [],
    custom_module: data.custom_module || [],
  };
};
